import { initializeApp } from 'firebase/app';
import { getDatabase, ref } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth, signInAnonymously } from "firebase/auth";
import { envtheme, ENV_STAGE, ENV_PROD, ENV_UAT, ENV_PROD_BLUE, ENV_UAT_SAF, ENV_PROD_SAF } from '../Config';

let apiKeyValue;
let authDomainValue;
let databaseURLValue;
let projectIdValue;
let storageBucketValue;
let appIdValue;

if (envtheme === ENV_STAGE) {
    apiKeyValue = process.env.REACT_APP_STAGE_API_KEY;
    authDomainValue = process.env.REACT_APP_STAGE_AUTH_DOMAIN;
    databaseURLValue = process.env.REACT_APP_STAGE_DATABASE_URL;
    projectIdValue = process.env.REACT_APP_STAGE_PROJECT_ID;
    storageBucketValue = process.env.REACT_APP_STAGE_STORAGE_BUCKET;
    appIdValue = process.env.REACT_APP_STAGE_APP_ID;
}
else if ((envtheme === ENV_PROD) || (envtheme === ENV_PROD_BLUE)) {
    apiKeyValue = process.env.REACT_APP_PROD_API_KEY;
    authDomainValue = process.env.REACT_APP_PROD_AUTH_DOMAIN;
    databaseURLValue = process.env.REACT_APP_PROD_DATABASE_URL;
    projectIdValue = process.env.REACT_APP_PROD_PROJECT_ID;
    storageBucketValue = process.env.REACT_APP_PROD_STORAGE_BUCKET;
    appIdValue = process.env.REACT_APP_PROD_APP_ID;
}
else if (envtheme === ENV_UAT) {
    apiKeyValue = process.env.REACT_APP_UAT_API_KEY;
    authDomainValue = process.env.REACT_APP_UAT_AUTH_DOMAIN;
    databaseURLValue = process.env.REACT_APP_UAT_DATABASE_URL;
    projectIdValue = process.env.REACT_APP_UAT_PROJECT_ID;
    storageBucketValue = process.env.REACT_APP_UAT_STORAGE_BUCKET;
    appIdValue = process.env.REACT_APP_UAT_APP_ID;
}
else if (envtheme === ENV_UAT_SAF) {
    console.log("envtheme:"+envtheme);
    apiKeyValue = process.env.REACT_APP_SAF_UAT_API_KEY;
    authDomainValue = process.env.REACT_APP_SAF_UAT_AUTH_DOMAIN;
    databaseURLValue = process.env.REACT_APP_SAF_UAT_DATABASE_URL;
    projectIdValue = process.env.REACT_APP_SAF_UAT_PROJECT_ID;
    storageBucketValue = process.env.REACT_APP_SAF_UAT_STORAGE_BUCKET;
    appIdValue = process.env.REACT_APP_SAF_UAT_APP_ID;
}
else if (envtheme === ENV_PROD_SAF) {
    console.log("envtheme:"+envtheme);
    apiKeyValue = process.env.REACT_APP_SAF_PROD_API_KEY;
    authDomainValue = process.env.REACT_APP_SAF_PROD_AUTH_DOMAIN;
    databaseURLValue = process.env.REACT_APP_SAF_PROD_DATABASE_URL;
    projectIdValue = process.env.REACT_APP_SAF_PROD_PROJECT_ID;
    storageBucketValue = process.env.REACT_APP_SAF_PROD_STORAGE_BUCKET;
    appIdValue = process.env.REACT_APP_SAF_PROD_APP_ID;
}
else {
    apiKeyValue = process.env.REACT_APP_DEV_API_KEY;
    authDomainValue = process.env.REACT_APP_DEV_AUTH_DOMAIN;
    databaseURLValue = process.env.REACT_APP_DEV_DATABASE_URL;
    projectIdValue = process.env.REACT_APP_DEV_PROJECT_ID;
    storageBucketValue = process.env.REACT_APP_DEV_STORAGE_BUCKET;
    appIdValue = process.env.REACT_APP_DEV_APP_ID;
}

const config = {
    apiKey: apiKeyValue,
    authDomain: authDomainValue,
    databaseURL: databaseURLValue,
    projectId: projectIdValue,
    storageBucket: storageBucketValue,
    appId: appIdValue
}

const app = initializeApp(config);

//firebase.auth().signInAnonymously();
const auth = getAuth(app);

// Sign in anonymously 
signInAnonymously(auth);

//firebase.analytics();  //firebase analytics
export const databaseRef = ref(getDatabase(app));

// Get a reference to the storage service, export it for use
export const storageRef = getStorage(app);
